// Get the query parameter
const getQueryParam = (param: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

// Set a query parameter in the URL
const setQueryParam = (param: string, value: string | null) => {
  const urlParams = new URLSearchParams(window.location.search);
  if (value) {
    urlParams.set(param, value);
  } else {
    urlParams.delete(param);
  }
  const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
  window.history.pushState({}, "", newUrl);
};

export { getQueryParam, setQueryParam };
